<template>
  <div class="pageNotFound">
    <div class="code">
      404
    </div>
    <div class="text">
      Страница не найдена
    </div>
    <div class="btn">
      <Button class="mr" label="На главную" @click="$router.push({ path: '/' })" />
    </div>
  </div>
</template>

<script>
import Button from '@/components/ui/Button'

export default {
  components: {
    Button
  }
}
</script>

<style lang="scss" scoped>
.pageNotFound{
  @include box(100%, 100%, absolute, 0, 0, null, null, 0, null);
  @include flex(center, center, column);
  .code{
    @include text(4vw, 300, 0.3vw, null, center, $text);
  }
  .text{
    @include text(1vw, 500, 0.1vw, null, center, $text);
    @include padding(0, 1vw, 0, 2vw);
  }
}
</style>
